import React, { ReactElement, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import Loader from '../components/Loader';
import { getToken, logout, setAuthData, userIsAuthenticated } from '../helpers/AuthHelpers';
import { useLoginAccessTokensQuery } from '../services/rtk/AuthAPI';

import '../styles/views/Login.less';

const Login = (): ReactElement => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const { data: authData, error: fetchAuthDataErr } = useLoginAccessTokensQuery(
        { code: searchParams.get('code') },
        { skip: !searchParams.get('code') || userIsAuthenticated(getToken()) }
    );

    useEffect(() => {
        if (!userIsAuthenticated(getToken()) && !searchParams.get('code')) {
            logout();
        }
    }, []);

    useEffect(() => {
        if (authData) {
            setAuthData(authData);
            const redirectUrl = sessionStorage.getItem('redirectTo');
            if (redirectUrl) {
                navigate(redirectUrl, { state: 'login' });
                sessionStorage.removeItem('redirectTo');
            } else {
                navigate('/');
            }
        }
    }, [authData]);

    useEffect(() => {
        if (fetchAuthDataErr) {
            navigate('/login-error');
        }
    }, [fetchAuthDataErr]);

    return <Loader size={15} loading={true} moonLoader={true} />;
};

export default Login;
